import React from 'react'
import type { IconProps } from './index'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const FontAwesome6Icon = ({ className, name, title }: IconProps) => {
  return <FontAwesomeIcon icon={name as any} title={title} className={className} name={name} />
}
